import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Token } from '../models/api_models/token';
import { GrantPassword } from '../models/api_models/grantPassword'
import { Router } from '@angular/router';
import { catchError, map, tap } from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class AutorizationService {

  publicUrl = "https://oauth.clem.mobi";
  oauthUrl = `https://oauth2.clem.mobi`;

  public token: Token;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })
  };



  constructor(private http: HttpClient, private router: Router) { }


  headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  });

  // private PostTokenClientGrantToken() {
  //   return this.http.post<any>(this.publicUrl + "/api/get_token", null, this.httpOptions);
  // }


  // private PostTokenPassportGrantToken(data: GrantPassword): Observable<Token> {
  //   return this.http.post<any>(this.oauthUrl + "/oauth/token", data.convertToPostParam(), this.httpOptions);
  // }


  private PostTokenClientGrantToken() {

    const body = new HttpParams()
    .set('grant_type', "client_credentials")
    .set('client_id', "clem.mobi-not-connected-ELmwNyiMiN!4aEqYcOxLBJazmkfBP9EAuI66P2IH")
    .set('client_secret', "1FWE8ov@UhfKOMGPKKQViGSuPdXgkjJ8!oRYnxJKC@fOjDA8$4")
   

    return this.http.post<any>(this.oauthUrl + "/oauth/v1/token", body , {headers: this.headers});
  }


  private PostTokenPassportGrantToken(data: any): Observable<Token> {

    const body = new HttpParams()
    .set('grant_type', "password")
    .set('username', data.username)
    .set('password', data.password)
    .set('client_id', "clem.mobi-connected-91r$oxwytlDScoBLOKG7mj$IhAKriMsSUUz$amsw")
    .set('client_secret', "6tO9!pHqZ9vtD7So2ElcPHwr0t1I!AVAO4WWf3D!bBVh@$$tke")
   

    return this.http.post<any>(this.oauthUrl + "/oauth/v1/token", body, this.httpOptions);
  }


  private refreshToken() {
    return this.http.post<any>(this.publicUrl + "/api/refresh_token", "refresh_token=" + this.token.refresh_token, this.httpOptions);
  }


  private saveTokenInSessionOffline() {
    let expiredDate = new Date();
    expiredDate.setDate(expiredDate.getDate() + 7);
    localStorage.setItem('token_offline', JSON.stringify(this.token));
  }


  private saveTokenInSession() {
    let expiredDate = new Date();
    expiredDate.setDate(expiredDate.getDate() + 7);
    localStorage.setItem('token_clem_mobi', JSON.stringify(this.token));
  }

  public getPublicToken() {
    this.loadTokenFromSession()
    return this.token;
  }


  private loadTokenFromSession() {
    let dataStr = localStorage.getItem('token_clem_mobi');
    if (dataStr == null || dataStr == "") {
      return false;
    }
    let obj = JSON.parse(dataStr);
    this.token = new Token(obj.access_token, obj.refresh_token, obj.expires_in, obj.grant_type);
    if (this.token.access_token == null) {
      return false;
    }
    return true;
  }



  public logout() {
    localStorage.removeItem('token_clem_mobi');
    localStorage.removeItem('token_offline');
    this.router.navigate(['/connexion']);
  }


  isHasBeenAuthenticated() {
    if (this.loadTokenFromSession() == false) {
      return false;
    }
    if (this.token == null || this.token.grant_type != "user_grant") {
      return false;
    }
    return true;
  }


  clearStorage() {
  }

  unlog() {

  }



  login(data: GrantPassword) {


    console.log(data)

    if (data == null) {
      return new Observable((observer) => {

        if (this.isHasBeenAuthenticated()) {
          if (this.token.isExpired()) {
            this.refreshToken().subscribe(reponse => {
              // console.warn(reponse);
              this.token = new Token(reponse.access_token, reponse.refresh_token, (reponse.expires_in * 1000) + Date.now(), "");
              this.token.grant_type = "user_grant";

              this.saveTokenInSession();
              observer.next(this.token);
              observer.complete();
            },
              error => {
                observer.error(error);
                observer.complete();
              })
          } else {

            observer.next(this.token);
            observer.complete();
          }
        } else {
          if (this.loadTokenFromSession() == false) {
            this.PostTokenClientGrantToken().subscribe(reponse => {

              this.token = new Token(reponse.access_token, "", (reponse.expires_in * 1000) + Date.now(), reponse.grant_type);
              this.saveTokenInSessionOffline();
              observer.next(this.token);
              observer.complete();
            }, error => {


              observer.error(error);
              observer.complete();

            });
          } else {
            observer.next(this.token);
            observer.complete();
          }
        }
      });
    }
    // // console.log(data);
    return new Observable((observer) => {
      this.PostTokenPassportGrantToken(data).subscribe(reponse => {
        // // console.log("user_token");
        // // console.log(reponse);
        this.token = new Token(reponse.access_token, reponse.refresh_token, (reponse.expires_in * 1000) + Date.now(), reponse.grant_type);
        // // console.log(this.token);
        this.token.grant_type = "user_grant";
        this.saveTokenInSession();

        observer.next(this.token);
        observer.complete();
      }, error => {
        // // console.error("Error 4");

        observer.error(error);
        observer.complete();

      });
    })
  }






 isAuth() {
    return new Observable((observer) => {
      if (!this.loadTokenFromSession()) {
        observer.next(false);
        observer.complete();
      } else if (this.token.isExpired()) {
        this.refreshToken().subscribe(reponse => {
          this.token = new Token(reponse.access_token, reponse.refresh_token, (reponse.expires_in * 1000) + Date.now(), reponse.grant_type);
          this.saveTokenInSession();
          observer.next(true);
          observer.complete();
        },
          error => {
            observer.error(false);
            observer.complete();
          }
        )
      } else {
        observer.next(true);
        observer.complete();
      }

    });
  }


getIP(){

  return this.http.get<any>('https://ip-inform.clem.mobi/');

}



      // refresh token methods

      private refreshTokenTimeout?: any;

      private startRefreshTokenTimer(expire) {
          // parse json object from base64 encoded jwt token
          // const jwtBase64 = this.userValue!.jwtToken!.split('.')[1];
          // const jwtToken = JSON.parse(atob(jwtBase64));
          
          // set a timeout to refresh the token a minute before it expires
          const expires = new Date(expire * 1000);
          const timeout = expires.getTime() - Date.now() - (60 * 1000);
          console.log(expires)
          console.log(timeout)
          this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
      }
  
      private stopRefreshTokenTimer() {
          clearTimeout(this.refreshTokenTimeout);
      }




          // get refresh token 
    refreshTokenApi(refresh_token: string): Observable<any> {

      const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('client_id', "clem.mobi-connected-91r$oxwytlDScoBLOKG7mj$IhAKriMsSUUz$amsw")
      .set('client_secret', "6tO9!pHqZ9vtD7So2ElcPHwr0t1I!AVAO4WWf3D!bBVh@$$tke")
      .set('refresh_token', refresh_token)
      return this.http.post<any>(`${this.oauthUrl}/oauth/v1/token`, body)
     
    }


     refreshTokenOauth2(data: string) {


    console.log(data)
    
    // // console.log(data);
    return new Observable((observer) => {
      this.refreshTokenApi(data).subscribe(reponse => {
        // // console.log("user_token");
        // // console.log(reponse);
        this.token = new Token(reponse.access_token, reponse.refresh_token, (reponse.expires_in * 1000) + Date.now(), reponse.grant_type);
        // // console.log(this.token);
        this.token.grant_type = "user_grant";
        this.saveTokenInSession();

        observer.next(this.token);
        observer.complete();
      }, error => {
        // // console.error("Error 4");

        observer.error(error);
        observer.complete();

      });
    })
  }
  


}
